<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useStatisticsWizardStore } from '../../stores';
import { StatisticsKind } from '@maximap-base';
import SoilTemperaturePeriod from './SoilTemperaturePeriod.vue';
import StatisticsWizardParcelCard from './StatisticsWizardParcelCard.vue';
import SourceLayerSelector from './SourceLayerSelector.vue';
import { needSourceLayerSelector } from '../../utils';
import { StatisticsInfo } from '..';

const statisticsWizardStore = useStatisticsWizardStore();
const { statisticsData, isParcelsLoading, isUiDisabled } = storeToRefs(statisticsWizardStore);
</script>

<template>
  <div class="h-100 d-flex flex-column">
    <div class="flex-grow-0">
      <v-row>
        <v-col
          cols="12"
          md="6">
          <v-card
            :title="$t('statistics.wizard.label.statisticsType')"
            :subtitle="statisticsData.kind ? $t(`statistics.statisticsKind.${statisticsData.kind}`) : '-'"
            variant="flat" />
        </v-col>
        <v-col
          cols="12"
          md="6">
          <v-card
            :title="$t('statistics.wizard.label.year')"
            :subtitle="statisticsData.year ? statisticsData.year.toString() : '-'"
            variant="flat" />
        </v-col>
      </v-row>
      <v-row
        :no-gutters="true"
        class="mb-4">
        <v-col cols="12">
          <v-card variant="flat">
            <v-card-item>
              <div class="d-flex flex-row justify-space-between">
                <v-btn
                  color="primary"
                  @click.prevent.stop="statisticsWizardStore.openParcelSelectorModal"
                  :loading="isParcelsLoading"
                  :disabled="isParcelsLoading || isUiDisabled">
                  {{ $t('statistics.wizard.label.openParcels') }}
                </v-btn>
                <div class="d-flex align-center ga-2">
                  <statistics-info
                    v-if="statisticsData.kind"
                    :component-name="'wizard'"
                    :statisticsKind="statisticsData.kind" />
                  <v-btn
                    variant="flat"
                    size="x-small"
                    :icon="true"
                    @click.prevent.stop="statisticsWizardStore.fitParcelsExtent()">
                    <v-icon
                      icon="mdi-magnify-minus-outline"
                      size="x-large" />
                  </v-btn>
                </div>
              </div>
            </v-card-item>
          </v-card>
        </v-col>
      </v-row>

      <v-divider />

      <source-layer-selector
        v-if="statisticsData.kind && needSourceLayerSelector(statisticsData.kind)"
        :kind="statisticsData.kind" />

      <v-divider v-if="statisticsData.kind === StatisticsKind.SOIL_TEMPERATURE" />

      <soil-temperature-period v-if="statisticsData.kind === StatisticsKind.SOIL_TEMPERATURE" />

      <v-divider></v-divider>
    </div>
    <div class="flex-grow-1 position-relative mt-4 mb-4">
      <div
        class="h-100 position-absolute d-flex flex-column align-content-lg-space-between overflow-x-hidden gap-1 pl-4 pr-4 pb-4 pt-1"
        style="top: 0; left: 0; right: 0; bottom: 0; overflow-y: scroll">
        <transition-group name="application-data-items">
          <statistics-wizard-parcel-card
            v-for="parcel in statisticsData.parcels"
            :key="parcel.id"
            :parcel="parcel" />
        </transition-group>
      </div>
    </div>
  </div>
</template>
